import React, { useEffect } from 'react';

function PreLoader() {
    useEffect(() => {
        const hideLoader = () => {
            document.getElementById('preloader').style.display = 'none';
        };

        // Hide the loader after 2000 milliseconds (2 seconds)
         const timeout = setTimeout(hideLoader,200);

       
        return () => clearTimeout(timeout);
    }, []);

    return (
        <div id="preloader" class="outer-loader">
            <div id="ctn-preloader" className="mainloader">
                <div className="animation-preloader">
                    <img src='/files/img/logo-dark-old.webp' className='mainloaderimg' loading="lazy" alt='loader'/>
                  <div className="spinner"></div>
                </div>
            </div>
        </div>
    );
}

export default PreLoader;
